import { Table } from '../../../components';

import React from 'react';
import PropTypes from 'prop-types';

const ResultCell = ({ result }) => (
  <Table.Cell className="lift result cell">
    {result === 0 ? '---' : result}
  </Table.Cell>
);

ResultCell.propTypes = {
  result: PropTypes.number,
};

export default ResultCell;



// WEBPACK FOOTER //
// ./src/terminals/Director/Protocol/ResultCell.js